import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { IRootState } from './root-state.store'
import * as StoreTypes from './root-types.store';
import { agendaModule } from './agenda';
import { ticketModule } from './ticket';
import { homeModule } from './home';
import { blockModule } from './block';
import { contactModule } from './contact';
import { authorizationModule } from './authorization';
import { userModule } from './user';
import { searchModule } from './search';
import { apartmentModule } from './apartment';
import { tenantModule } from './tenant';
import { settingsModule } from './settings';
import { profileModule } from './profile';
import { documentModule } from './document';
import { profileNotificationModule } from './profile-notification';

// @ts-ignore
import { createSocketPlugin } from './_plugin/root-plugin.store';
import io = require('socket.io-client');
import { notificationModule } from './notification';
import { ownerModule } from './owner';
import { receptionModule } from './reception';
import { buildingMonitorModule } from './building-monitor';
import { maintenanceModule } from './maintenance'
import { ActivityStatus } from '../common/enums';
import {agencyManagementModule} from "./agency-management";
import {serviceBookModule} from "./service-book"

const socket = io(process.env.BASE_URL);
socket.on('connect_error', (err) => {
  if (err === 'timeout') {
    try {
      console.log(socket);
      socket.connect()
    } catch (er) {
      console.log('err', er);
    }
  }
})
Vue.use(Vuex);

const store = new Store<IRootState | any>({
  plugins: [createSocketPlugin(socket)],
  strict: true,
  modules: {
    authorization: authorizationModule,
    user: userModule,
    agenda: agendaModule,
    ticket: ticketModule,
    home: homeModule,
    block: blockModule,
    contact: contactModule,
    search: searchModule,
    apartment: apartmentModule,
    tenant: tenantModule,
    notification: notificationModule,
    settings: settingsModule,
    owner: ownerModule,
    profile: profileModule,
    document: documentModule,
    profileNotification: profileNotificationModule,
    reception: receptionModule,
    bm: buildingMonitorModule,
    maintenance: maintenanceModule,
    am: agencyManagementModule,
    serviceBook:serviceBookModule
  },
  state: {
    configuration: {
      activityStatus: ActivityStatus.NoActivity,
      info: {
        style: {
          width: "13vh",
          'object-fit': 'cover'
        }
      },
      err: null,
    },
    serviceWorker: {
      showSnackbar: false,
      worker: null
    }
  }
  ,
  mutations: {
    ['RECIEVE_CONFIGURATION']: (state, data) => {

      state['configuration'].activityStatus = ActivityStatus.Loaded;
      let style: any = {}
      state.configuration.info = {...state.configuration.info, ...data}

      const getImage = (value/*, height?*/) => {

        /*if (typeof height !== 'undefined') {
          console.log(value, height);
        }*/

        const image = new Image();
        image.src = value;
        image.onload = (event: any) => {
          console.log('EVENT ==========', event)
          let target;
          if (event.path) {
            target = event.path[0]
            console.log('EVENT PATH 0 ==========', event.path[0])
          } else if (event.target) {
            target = event.target
            console.log('EVENT target ==========', event.target)
          } else {
            console.log('EVENT WITHOUT IMAGE VALUE')
            return
          }
          console.log('target ==========', target)
          const { width, height } = target;
          const whRadio = width / height;

          if (whRadio > 1 && width > 150) {
            style.width = `${13 * 2}vh`;
            style['object-fit'] = `cover`;
            style['margin-bottom'] = '0 !important'
             state.configuration.info.style = style;
          }
        }

      }
      getImage(data.logo);

    },
    ['RECIEVE_CONFIGURATION_FAILED']: (state, err) => {
      state['configuration'] = {
        err: null,
        activityStatus: ActivityStatus.LoadFailed
      }
    },
    ['UPDATE_SNACKBAR_STATUS']: (state,status) => {
      state['serviceWorker'] = {
        ...state['serviceWorker'],
        showSnackbar: status
      }
    },
    ['UPDATE_WORKER']: (state,worker) => {
      state['serviceWorker']= {
        ...state['serviceWorker'],
        worker
      }
    }
  },
  getters: {
    configuration: (state) => state['configuration'],
    serviceWorker: (state) => state['serviceWorker']
  }
});

export { store as default, StoreTypes };



// WEBPACK FOOTER //
// ./src/store/index.ts